import type { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <p className="text-lg font-semibold text-primary">{title}</p>
      {description && <p className="max-w-sm text-sm text-secondary">{description}</p>}
      {action}
    </div>
  );
}
